module.exports = __webpack_public_path__ + "static/media/veriff-logo.8de3b62e.svg";